export default {
  Title: 'Reviews',
  NumberOfReview: '(#{numReviews} review)',
  NumberOfReviews: '(#{numReviews} reviews)',
  Subtitle: 'See what clients, families, and healthcare professionals say about #{caregiverName}\'s care',
  Verified: 'Verified',
};
